import Vue from 'vue'
export default class MessageQueue {
  constructor() {
    this.queue = []; // 用于存储消息的数组
  }

  // 入队操作：在队列尾部添加消息
  enqueue(message) {
    this.queue.push(message);
    console.log(`消息入队：${message}`);
  }

  // 出队操作：从队列头部移除消息
  dequeue() {
    if (this.queue.length === 0) {
      console.log("队列为空，无法执行出队操作");
      return null;
    }
    const message = this.queue.shift();
    console.log(`消息出队：${message}`);
    return message;
  }

  // 查看队列头部的消息但不移除
  peek() {
    if (this.queue.length === 0) {
      console.log("队列为空");
      return null;
    }
    return this.queue[0];
  }

  // 检查队列是否为空
  isEmpty() {
    return this.queue.length === 0;
  }

  // 获取队列中的消息数量
  size() {
    return this.queue.length;
  }

  // 清空队列
  clear() {
    this.queue = [];
    console.log("队列已清空");
  }
}